









































































import { Component, Mixins } from "vue-property-decorator";
import dateranges from "@/data/dateranges";
import AdminBrandId from "@/mixins/adminBrandId";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import { serialiseConfig } from "@/helpers/table";
import { FilterOperators } from "@/data/table";
import { routeToAdminLogsFromOrders } from "@/data/filters/timeline";

@Component({
  methods: { routeToAdminLogsFromOrders },
  components: {
    "chart-provider": () =>
      import("@/components/app/global/stats/charts/chart/chartProvider.vue"),
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "orders-total": () =>
      import("@/components/app/global/stats/ordersTotal.vue"),
    "orders-average-value": () =>
      import("@/components/app/global/stats/orderAverageValue.vue"),
    "chart-orders": () =>
      import("@/components/app/global/stats/charts/ordersChart.vue"),
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue"),
    "recent-orders": () =>
      import("@/components/app/global/orders/recentOrdersList.vue"),
    "orders-provider": () =>
      import("@/components/app/global/orders/ordersProvider.vue")
  }
})
export default class AdminOrdersOverview extends Mixins(
  AdminBrandId,
  StatsStorageMixin
) {
  public range = this.tryGetStatDateFromStorage(dateranges.ranges.last30days);
  public currencyCode = null;
  public orderTableParams = serialiseConfig({
    constFilters: [
      {
        key: "status.code",
        operator: FilterOperators.EQUAL,
        value: ["contract_active", "contract_pending"]
      }
    ]
  });
}
